import { createRoute,lazyRouteComponent } from '@tanstack/react-router'

import { sponsorsRoute } from '.'

const SponsorsDetails = lazyRouteComponent(
  () => import('../../pages/sponsors/sponsors-details'),
)

export const sponsorsDetailsRoute = createRoute({
  getParentRoute: () => sponsorsRoute,
  path: '$slug',
  component: SponsorsDetails,
})
